import { useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";

export interface UseEnduserFilesOptions {
  limit?: number;
  /** Whether to enable the query (defaults to true) */
  enabled?: boolean;
}

export function useEnduserFiles(options: UseEnduserFilesOptions = {}) {
  const { limit = 50, enabled = true } = options;

  const query = useTellescopeInfiniteQuery({
    model: "files",
    method: "getSome",
    request: {
      filter: {},
      limit,
    },
    select: (data) => data.pages.flat(),
    enabled,
  });

  const allFiles = query.data ?? [];

  // Filter out files hidden from enduser portal
  const visibleFiles = allFiles.filter((file) => !file.hiddenFromEnduser && !file.hideFromEnduserPortal);

  // Sort by timestamp/updatedAt (most recent first)
  const sortedFiles = [...visibleFiles].sort((a, b) => {
    const aTime = a.timestamp ? new Date(a.timestamp).getTime() : new Date(a.updatedAt).getTime();
    const bTime = b.timestamp ? new Date(b.timestamp).getTime() : new Date(b.updatedAt).getTime();
    return bTime - aTime;
  });

  return {
    ...query,
    files: sortedFiles,
  };
}
